<template>
    <div class="clearfix userCenterView enterpriseCertification">
        <div class="fr"><Bread :prop="bread" /></div>
        <div class="contentWrap fl"  style="width:100%">
            <div class="contentTitle">站内信</div>
            <div class="content" style="height:450px;">
                <BasicTable 
                :tableData="tableData" 
                :columns="columns" 
                style="height:98%;margin:30px 0;"
                :pageSize="pageQuery.page_size"
                @pageChange="pageChange"
                :total="pageQuery.total">
                    <template v-slot:send_time="{ item }">
                        {{item.send_time*1000 | dateFormat('YYYY-MM-DD') }}
                    </template>
                    <template v-slot:msg_type="{ item }">
                        {{item.msg_type ===1 ?'全体消息':'个体消息'}}
                    </template>
                </BasicTable>
                
            </div>
        </div>
    </div>
</template>

<script>
import Bread from '@/components/Bread/index'
import { UserCenterService } from '../../../service/userCenter.service'

const columns = [
  { name: '信件标题', key: 'title' },
  { name: '发送时间', key: 'send_time',type: 'custom'},
  { name: '信息类型', key: 'msg_type',type: 'custom' },
];

export default {
    components:{ Bread },
    data() {
        return {
            bread: [{
                name: '用户中心',
                path: '/userCenter/index'
            },{
                name: '站内信',
                path: '/userCenter/score'
            }],
            tableData:[],
            columns,
            pageQuery:{
                page: 1,
                total: 0,
                page_size:2
            }
        }
    },
    methods: {
        async getList() {
            const data = await UserCenterService.messageList(this.pageQuery)
            this.tableData = JSON.parse(JSON.stringify(data.list))
            this.pageQuery.total = data.totalRow
        },
        async pageChange(index) {
            this.pageQuery.page = index
            const data = await UserCenterService.messageList(this.pageQuery);
            this.tableData = JSON.parse(JSON.stringify(data.list))
        },
    },
    created() {
        this.getList()
    }
    
}
</script>
<style lang="scss" scoped>
    .userCenterView{
        width: 935px;
        .content{
            padding: 40px 30px 50px 30px;
            border: 1px solid #e3e2e1;
            display: block;
            .scoreTitle{
                font-size: 16px;
                font-weight: 700;
            }
        }
    }
</style>